
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed, ref, ComponentPublicInstance,nextTick, PropType } from "vue";
import { getApplianceCategoryWhiteIcon } from "@/utils/resource-util";
import { convertRemToPx } from "@/utils/common-utils";
import { ApplianceData, AttachmentData } from "@/types/common";
import { Attachment, LINK_TYPE } from "@/types/recipes";
import { SEARCH_APPLIANCE_CATEGORY_ID } from "@/types/search";
export default defineComponent({
  name: "DetailInstructionItem",
  props: {
    step: {
      type: Number
    },
    description: {
      type: String
    },
    note: {
      type: String
    },
    applianceCategory: {
      type: String,
      required: true
    },
    applianceCategoryId: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String
    },
    dlMenuId: {
      type: Number
    },
    lastItem: {
      type: Boolean,
      default: false
    },
    update: {
      type: Boolean,
      default: false
    },
    applianceData: {
      type: ApplianceData,
      require: true
    },
    recipeAttachmenList: {
      type: Array as PropType<Attachment[]>
    },
    attachmentList: {
      type: Array as PropType<AttachmentData[]>,
      require: true
    },
    pageScrollTop: {
      type: Number,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const IMAGE_WIDTH_PADDING = 4.8;
    const instructionView = ref<ComponentPublicInstance<HTMLElement>>();
    const descriptionText = ref<ComponentPublicInstance<HTMLElement>>();
    const enableBistroAttachment = ref(false);
    const bistroSendLink = ref(false);
    const bistroSendLinkAttachment = ref(false);

    NativeClient.sendDebugLog("DetailInstructionItem setup recipeAttachmenList=" + JSON.stringify(props.recipeAttachmenList));
    const isShowNote = () => {
      return props.note;
    };
    const isShowDivider = () => {
      return !props.lastItem;
    };
    /**
     * 機種アイコンを取得する
     */
    const getCategoryIcon = (applianceCategoryId: number) => {
      const icon = getApplianceCategoryWhiteIcon(applianceCategoryId);
      return icon;
    };
    const isBistroSendEnable = () => {
      return (props.applianceData != null && props.applianceData.applianceId != null && props.applianceData.applianceId != "");
    };
    const isBistroSendEnableAttachment = () => {
      let enableAttachment = false;
      if (props.recipeAttachmenList) {
        if (props.recipeAttachmenList.length >= 1) {
          if (props.attachmentList) {
            for (const recipeAttachment of props.recipeAttachmenList) {
              for (const attachment of props.attachmentList) {
                if (recipeAttachment.id == attachment.attachmentCode && attachment.activated) {
                  enableAttachment = true;
                  break;
                }
              }
            }
          } else {
            enableAttachment = false;
          }
        } else {
          enableAttachment = true;
        }
      }
      return enableAttachment;
    };
    const isShowBistroSend = () => {
      return props.dlMenuId;
    };
    const getClassBistroSendView = () => {
      const enabled = isBistroSendEnable() && enableBistroAttachment.value;
      return enabled ? "detail-instruction-item-bistro-send-enable-view " : "detail-instruction-item-bistro-send-disable-view ";
    };
    const isBistroSendLinkDisable = () => {
      const show = !isBistroSendEnable();
      return show;
    };
    const isBistroSendLinkAttachment = () => {
      const show = !isBistroSendEnableAttachment();
      return show;
    };
    const setATagUrl = () => {
      const anchors = descriptionText.value?.getElementsByTagName('a');
      if (anchors) {
        Array.from(anchors).forEach(anchor => {
          const oldHref = anchor.getAttribute('href');
          NativeClient.sendDebugLog("DetailInstructionItem setAtagUrl oldHref=" + oldHref);
          if (oldHref != null) {
            const index = oldHref.indexOf("?");
            NativeClient.sendDebugLog("DetailInstructionItem setAtagUrl index=" + index);
            let query = "";
            if (index != -1) {
              const windowIndex = oldHref.indexOf('window', index);
              NativeClient.sendDebugLog("DetailInstructionItem setAtagUrl windowIndex=" + windowIndex);
              if (windowIndex == -1) {
                query = "&window=browser";
              }
            } else {
              query = "?window=browser";
            }
            const newHref = oldHref + query;
            NativeClient.sendDebugLog("DetailInstructionItem setAtagUrl newHref=" + newHref);
            anchor.setAttribute('href', newHref);
          }
        });
      }
    };
    const setShowData = () => {
      const isBistroSend = isShowBistroSend();
      let bistroSendEnable = false;
      let bistroSendEnableAttachment = false;
      let sendLinkAttachment = false;
      if (isBistroSend) {
        bistroSendEnable = isBistroSendLinkDisable();
        bistroSendEnableAttachment = isBistroSendEnableAttachment();
        sendLinkAttachment = isBistroSendLinkAttachment();
      }
      NativeClient.sendDebugLog("DetailInstructionItem setInstructionPosition step=" + props.step + " dlMenuId=" + props.dlMenuId + " bistroSendEnable=" + bistroSendEnable + " sendLinkAttachment=" + sendLinkAttachment);
      NativeClient.sendDebugLog("DetailInstructionItem setInstructionPosition step=" + props.step + " dlMenuId=" + props.dlMenuId + " props.applianceData=" + (props.applianceData != null ? JSON.stringify(props.applianceData) : "null"));
      enableBistroAttachment.value = (bistroSendEnableAttachment == true);
      bistroSendLink.value = (bistroSendEnable == true);
      bistroSendLinkAttachment.value = false;
      if (!bistroSendLink.value) {
        bistroSendLinkAttachment.value = (sendLinkAttachment == true);
      }
    };
    const setInstructionPosition = () => {
      NativeClient.sendDebugLog("DetailInstructionItem setInstructionPosition step=" + props.step + " dlMenuId=" + props.dlMenuId + " enableBistroAttachment=" + enableBistroAttachment.value + " bistroSendLink=" + bistroSendLink.value + " bistroSendLinkAttachment=" + bistroSendLinkAttachment.value);
      const rect = instructionView.value?.getBoundingClientRect();
      NativeClient.sendDebugLog("DetailInstructionItem setInstructionPosition rect=" + JSON.stringify(rect) + " pageScrollTop=" + props.pageScrollTop);
      NativeClient.sendDebugLog("DetailInstructionItem setInstructionPosition window=" + JSON.stringify(window.pageYOffset));
      context.emit("set-instruction-item-position", props.step, rect, props.pageScrollTop);
    };
    const updateDetail = computed(async () => {
      if (props.update) {
        setShowData();
        await nextTick(() => {
          setInstructionPosition();
          setATagUrl();
        });
      }
    });
    const clickBistroSend = () => {
      const enabled = isBistroSendEnable() && isBistroSendEnableAttachment();
      if (enabled) {
        context.emit("click-bistro-send", props.dlMenuId);
      }
    };
    const clickBistroSendLinkAppliance = () => {
      NativeClient.sendDebugLog("DetailInstructionItem clickBistroSendLinkAppliance");
      context.emit("click-bistro-send-link", LINK_TYPE.SHOW_APPLIANCE_LIST);
    };
    const clickBistroSendLinkAttachment = () => {
      NativeClient.sendDebugLog("DetailInstructionItem clickBistroSendLinkAttachment");
      context.emit("click-bistro-send-link", LINK_TYPE.SHOW_ATTACHMENT_LIST);
    };
    const getAttachmentName = () => {
      let attachmentName = "";
      if (props.recipeAttachmenList != null && props.recipeAttachmenList.length >= 1) {
        attachmentName = props.recipeAttachmenList[0].description != null ? props.recipeAttachmenList[0].description : "";
      }
      return attachmentName;
    };
    const getBistroMessage = () => {
      let result;
      switch (props.applianceCategoryId) {
        case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER:
        case SEARCH_APPLIANCE_CATEGORY_ID.RICE_COOKER_AUTO_WEIGHTING:
          result = "炊飯器へ送信";
          break;
        case SEARCH_APPLIANCE_CATEGORY_ID.AUTO_COKKER:
          result = "オートクッカーへ送信";
          break;
        default:
          result = "Bistroへ送信";
          break;
      }
      return result;
    };
    const styleImage = computed(() => {
      const width = window.innerWidth;
      const padding = convertRemToPx(IMAGE_WIDTH_PADDING);
      const imageWidth = width - (padding * 2);
      const imageHeight = Math.round(imageWidth * 3 / 4);
      NativeClient.sendDebugLog("DetailInstructionItem styleImage width=" + width + " padding=" + padding + " imageWidth=" + imageWidth + " imageHeight=" + imageHeight);
      return { height: imageHeight + `px`, width: imageWidth + `px` };
    });
    return {
      isShowNote,
      isShowDivider,
      getCategoryIcon,
      isShowBistroSend,
      instructionView,
      updateDetail,
      clickBistroSend,
      isBistroSendEnable,
      getClassBistroSendView,
      isBistroSendLinkDisable,
      isBistroSendLinkAttachment,
      enableBistroAttachment,
      bistroSendLink,
      bistroSendLinkAttachment,
      descriptionText,
      getAttachmentName,
      clickBistroSendLinkAppliance,
      clickBistroSendLinkAttachment,
      getBistroMessage,
      styleImage
    };
  }
});
